import { render } from "./searchResults.vue?vue&type=template&id=3bd7cbd7&scoped=true"
import script from "./searchResults.vue?vue&type=script&lang=js"
export * from "./searchResults.vue?vue&type=script&lang=js"

import "./searchResults.vue?vue&type=style&index=0&id=3bd7cbd7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd7cbd7"]])

export default __exports__